import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import BsForm from 'cpc-license-manager/components/bs-form';
import BsButton from 'cpc-license-manager/components/bs-button';
class SearchBox extends Component {
    @tracked
    searchTerm;
    get currentTerm() {
        return this.searchTerm || this.args.searchTerm;
    }
    set currentTerm(value) {
        this.searchTerm = value;
    }
    @action
    search() {
        this.args.onSubmit?.(this.searchTerm);
    }
    @action
    clear() {
        this.currentTerm = null;
        this.args.onClear?.();
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <BsForm @model={{this}} @onSubmit={{this.search}} as |form|>
      <form.element @property="currentTerm" class="mb-0" as |el|>
        <div class="input-group">
          <el.control class="search" placeholder={{@placeholder}} />
          {{#if @searchTerm}}
            <div {{on 'click' this.clear}} class="form-control-clear">
              <FaIcon @icon="times" />
            </div>
          {{/if}}
          <BsButton @type="outline-secondary" @size="sm" class="px-3" type="submit">
            <FaIcon @icon="search" />
          </BsButton>
        </div>
      </form.element>
    </BsForm>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default SearchBox;
